const createContextFilter = (context, getFilterValues) => {
  const processFilter = (filter) => {
    if (filter && (typeof filter === 'string')) {
      const lowFilter = filter.toLowerCase();
      return s => s.toLowerCase().indexOf(lowFilter) >= 0;
    }
    return null;
  };

  const aggregateFilters = (filter1, filter2) => {
    const f1 = processFilter(filter1);
    const f2 = processFilter(filter2);
    if (!f1) return f2 || undefined;
    if (!f2) return f1;
    return value => f1(value) && f2(value);
  };

  const filter = aggregateFilters(
    context && context.filter,
    context && context.search,
  );
  if (!filter) {
    return null;
  }

  return (obj) => {
    const values = getFilterValues(obj);
    return values.find(value => (value !== undefined) && (value !== null) && filter(value));
  };
};

export default createContextFilter;
